import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Button, Card, Row, Col, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Loading } from '@rd-web-markets/shared/dist/util';
import { EmployeeBioRow } from './';
import claimEmployeesService from '../../services/claim/claim_employees.service';
import ClaimStateAlerts from '@rd-web-markets/shared/dist/claim/ClaimStateAlerts';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { useDispatch } from 'react-redux';
import sortObjectsByProperty from '@rd-web-markets/shared/dist/util/helpers/sort_objects_by_property';
export const EmployeesBioSection = _ref => {
  let {
    accountType,
    claim,
    refreshClaim,
    project
  } = _ref;
  const [claimEmployees, setClaimEmployees] = useState(null);
  const dispatch = useDispatch();
  const claimId = useMemo(() => claim?.id, [claim]);
  const newEmployee = {
    name: '',
    role: '',
    bio: '',
    include_in_technical_report: false,
    claim_id: claim.id,
    claim_project_report_id: project.id
  };
  useEffect(() => {
    async function getData() {
      try {
        if (claimId) {
          setClaimEmployees(await claimEmployeesService.all(claimId, project.id));
        }
      } catch (error) {
        dispatch(handleError(error));
      }
    }
    getData();
  }, [dispatch, claimId]);
  const handleDelete = async index => {
    const employee = claimEmployees[index];
    if (employee.id) {
      try {
        await claimEmployeesService.delete(employee, project.id);
        const employees = await claimEmployeesService.all(claim.id, project.id);
        setClaimEmployees(employees);
        refreshClaim();
      } catch (error) {
        dispatch(handleError(error));
      }
    } else {
      const newEmployees = [...claimEmployees];
      newEmployees.splice(index, 1);
      setClaimEmployees(newEmployees);
    }
  };
  const handleAdd = () => {
    setClaimEmployees([...claimEmployees, {
      ...newEmployee
    }]);
  };
  const handleEmployeesSort = useCallback(sortBy => {
    const sortedClaimEmployees = sortObjectsByProperty([...claimEmployees], sortBy);
    setClaimEmployees(sortedClaimEmployees);
  }, [claimEmployees]);
  if (!claim || !claimEmployees) return /*#__PURE__*/React.createElement(Loading, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(ClaimStateAlerts, {
    claim: claim
  }), claimEmployees.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Table, {
    striped: true
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    onClick: () => handleEmployeesSort('name'),
    role: "button"
  }, "Employee"), /*#__PURE__*/React.createElement("th", {
    onClick: () => handleEmployeesSort('job_role'),
    role: "button"
  }, "Job role, experience and relevant qualifications"), /*#__PURE__*/React.createElement("th", null))), /*#__PURE__*/React.createElement("tbody", null, claimEmployees.map((employee, index) => {
    return /*#__PURE__*/React.createElement(EmployeeBioRow, {
      key: index,
      index: index,
      handleAdd: handleAdd,
      handleDelete: () => handleDelete(index),
      claimEmployees: claimEmployees,
      setClaimEmployees: setClaimEmployees,
      claim: claim
    });
  })))) : /*#__PURE__*/React.createElement(Row, {
    className: "pt-5 pb-5 text-center"
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h3", {
    className: "text-center text-muted"
  }, "No data"))), /*#__PURE__*/React.createElement(Row, {
    className: "mt-4"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "link",
    onClick: () => handleAdd(),
    disabled: claim.is_locked || claim.financials_locked || claim.active_change_set
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "add"), " Add Row"))), /*#__PURE__*/React.createElement(Card.Footer, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 6,
    className: "text-start"
  }, /*#__PURE__*/React.createElement(Button, {
    as: Link,
    variant: "light",
    to: `/${accountType}/claims/${claim.id}/financial_details/general`
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "chevron_left"), " Back")), /*#__PURE__*/React.createElement(Col, {
    md: 6,
    className: "text-end"
  }, /*#__PURE__*/React.createElement(Button, {
    as: Link,
    variant: "primary",
    to: `/${accountType}/claims/${claim.id}/financial_details/employees_activity`
  }, "Continue ", /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "chevron_right"))))));
};